// extracted by mini-css-extract-plugin
export default {"overflow":"remove-device-modal_overflow__FyENq"};